import React, { useEffect } from 'react';

const CheckoutBridge = () => {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const sessionId = params.get('sessionId') || localStorage.getItem('customerSessionId');
      const merchantBase = process.env.REACT_APP_MERCHANT_BASE_URL || 'http://localhost:3000';
      const search = window.location.search || '';
      const url = new URL(`${merchantBase}/checkout${search}`);
      if (sessionId && !url.searchParams.get('sessionId')) {
        url.searchParams.set('sessionId', sessionId);
      }
      window.location.replace(url.toString());
    } catch (e) {
      // noop - leave spinner visible
    }
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <div style={{ textAlign: 'center', color: '#6B7280' }}>
        <div style={{
          width: 48,
          height: 48,
          border: '4px solid #F3F4F6',
          borderTop: '4px solid #0D7463',
          borderRadius: '50%',
          margin: '0 auto 12px',
          animation: 'spin 1s linear infinite'
        }} />
        <p>Redirecting to checkout…</p>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }`}</style>
      </div>
    </div>
  );
};

export default CheckoutBridge;


